export const environment = {
  production: false,
  apiBaseUrl: 'https://meccustomeronboarding-service-cdt.maersk.io',
  useMockData: false,
};
